// extracted by mini-css-extract-plugin
module.exports = {"cover":"Cover_cover__2j1oY"};